// extracted by mini-css-extract-plugin
export default {"main":"Reviews_main__ugU6A"};